export default "__VITE_ASSET__sk8a6laU__"